import type { FC } from "react";
import { Link } from "react-router-dom";
import { toAbsoluteUrl } from "../../../../_metronic/helpers";

const Error403: FC = () => {
	const loggedIn = localStorage.getItem("Logined") === "true";
	return (
		<>
			{/* begin::Title */}
			<h1 className="fw-bolder fs-2hx text-danger mb-4">Oops!</h1>
			{/* end::Title */}

			{/* begin::Text */}
			<div className="fw-semibold fs-6 text-gray-500 mb-2">
				You don’t have permission to access this page.
			</div>
			{/* end::Text */}

			{/* begin::Illustration */}
			<div className="mb-3">
				<img
					src={toAbsoluteUrl("media/auth/403-error.jpg")}
					className="mw-100 mh-250px theme-light-show"
					alt=""
				/>
				<img
					src={toAbsoluteUrl("media/auth/403-error.jpg")}
					className="mw-100 mh-300px theme-dark-show"
					alt=""
				/>
			</div>
			{/* end::Illustration */}

			{/* begin::Link */}
			<div className="mb-0">
				<Link to={loggedIn ? "/" : "/auth"} className="btn btn-sm btn-primary">
					Return to Home
				</Link>
			</div>
			{/* end::Link */}
		</>
	);
};

export { Error403 };
